/* eslint-disable import/named */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react'
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup, Box,
  Grid, makeStyles, TextField,
} from '@material-ui/core'
import withWidth, { } from '@material-ui/core/withWidth'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
// import clsx from 'clsx'
// import axios from 'axios'
import PropTypes from 'prop-types'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import { withStyles } from '@material-ui/core/styles'
import { orange } from '@material-ui/core/colors'
import mellat from '../../assets/img/mellat.png'
import saman from '../../assets/img/saman.png'
import {
  payUserPackage, checkDiscount, selectorDiscountPrice, payExpiredUserPackage,
} from '../../app/slices/packageSlice'
import { payExpirePublicCourse, checkEpiredPublicCourseDiscount, selectorPublicCourseDiscount } from '../../app/slices/courseSlice'
// import { selectorLoading } from '../../app/slices/loadingSlice'
import { thousandSeperator } from '../../utils/getInitials'
import { replaceRegN } from '../../utils/CustomString'
import styles from '../../views/auth/register/PaymentStep.module.css'

const GreenCheckbox = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

export const bankPortals = [
  {
    name: 'mellat',
    desc: 'bank_mellat_payment_gateway',
    url: mellat,
  },
  {
    name: 'saman',
    desc: 'bank_saman_payment_gateway',
    url: saman,
  },
]

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
  },
  titleSection: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  package: {
    minHeight: theme.spacing(7),
    margin: theme.spacing(2, 0, 1.5, 0),
    padding: theme.spacing(0, 2.3, 0, 2),
    borderRadius: theme.spacing(0.7),
    backgroundColor: '#eeeeee',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  packageDiscount: {
    width: '100%',
    justifyContent: 'center',
  },
  packageDetail: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    color: '#000',
  },
  description: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  descriptionExam: {
    fontSize: theme.spacing(2),
    color: '#0080ff',
    marginLeft: theme.spacing(2.3),
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'flex-start',
    },
  },
  discount: {
  },
  bankGroup: {
    margin: '30px auto 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  portal: {
    marginBottom: theme.spacing(2),
  },
  portalLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.spacing(1.5),
    },
  },
  bankImage: {
    width: theme.spacing(9.1),
    height: theme.spacing(7.7),
    verticalAlign: 'middle',
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(6.1),
      height: theme.spacing(4.7),
    },
  },
  buttonContainer: {
    margin: '2rem auto 0',
  },
  form: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  formContainer: {
    flexGrow: 1,
  },
  item: {
    height: theme.spacing(14),
    padding: theme.spacing(1.5),
  },
  buttonBack: {
    width: theme.spacing(20),
    marginRight: theme.spacing(2),
  },
  buttonNext: {
    width: theme.spacing(20),
  },
  buttonRegisterWrap: {
    width: '100%',
    margin: '10px auto 0 auto',
    display: 'flex',
    alignSelf: 'center',
  },
  buttonPayment: {
    width: '80%',
    height: '64px',
    color: '#ffffff',
    backgroundColor: '#f9b233',
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    margin: '20px auto 40px',
    borderRadius: '10px',
    fontSize: '18px',
    fontWeight: 'bold',
    '& .MuiButton-label': {
      height: '60px',
    },
  },
  customInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px auto 10px',
    width: '80%',
    paddingLeft: '0',
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0 !important',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      display: 'flex',
      alignSelf: 'flex-start',
    },
  },
  customInput2: {
    display: 'block',
    marginTop: '5px',
    padding: '0',
    marginRight: '0',
    width: '100%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(6, 4),
    width: '40%',
    borderRadius: '20px',
    height: '40vh',
    overflow: 'hidden',
    '@media (max-width: 1400px)': {
      width: '50%',
    },
    '@media (max-width: 1200px)': {
      width: '60%',
    },
    '@media (max-width: 900px)': {
      width: '65%',
      height: '65vh',
    },
    '@media (max-width: 750px)': {
      width: '75%',
      height: '50vh',
    },
    '@media (max-width: 600px)': {
      width: '80%',
      height: '45vh',
    },
    '@media (max-width: 400px)': {
      width: '85%',
      height: '42vh',
    },
  },
  modalContent: {
    width: '100%',
    height: '100%',
    overflowY: 'scroll',
    boxSizing: 'content-box',
    paddingRight: '32px',
  },
  modalDesc: {
    fontSize: '18px',
    marginTop: '25px',
    marginBottom: '25px',
    lineHeight: '1.6',
    textAlign: 'justify',
    '@media (max-width: 960px)': {
      fontSize: '16',
    },
    '@media (max-width: 600px)': {
      fontSize: '14px',
    },
  },
  modalTitle: {
    marginTop: '20px',
    '@media (max-width: 960px)': {
      fontSize: '20px',
    },
    '@media (max-width: 600px)': {
      fontSize: '16px',
    },
  },

}))

const validationSchema = Yup.object().shape({
  discount: Yup.string()
    .max(255),
  // portal: Yup.mixed()
  // // .oneOf([1, 2])
  //   .required('err'),
})

const initialValues = {
  discount: '',
}

const BankPortal = ({ pkg, expired, expiredPackage }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  // const loading = useSelector(selectorLoading)
  const discountPrice = useSelector(selectorDiscountPrice)
  const expiredPublicCoursePrice = useSelector(selectorPublicCourseDiscount)
  const dispatch = useDispatch()

  console.log(expiredPublicCoursePrice)

  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (fields) => {
      // const { portal, discount } = fields
      const { portal, discount } = fields
      const ipg = bankPortals.findIndex((bank) => bank.name === portal) + 1
      const discountcode = discount || undefined
      // const discountcode = '100percent' || undefined
      // const callBackUrl = 'http://localhost:4000/BankResult'
      const callBackUrl = `${window.location.origin}/BankResult`

      if (expired) {
        dispatch(payExpirePublicCourse({ ipg, callBackUrl, discountcode }))
      } else if (expiredPackage) {
        dispatch(payExpiredUserPackage({ ipg, callBackUrl, discountcode }))
      } else {
        dispatch(payUserPackage({ ipg, callBackUrl, discountcode }, navigate))
      }
      // expired ? dispatch(payExpirePublicCourse({ ipg, callBackUrl, discountcode }))
      //   : dispatch(payUserPackage({ ipg, callBackUrl, discountcode }, navigate))
    },
  })

  const addDiscount = () => {
    if (expired) {
      dispatch(checkEpiredPublicCourseDiscount(formik.values.discount))
    } else {
      dispatch(checkDiscount(formik.values.discount))
    }
    // dispatch(checkDiscount(formik.values.discount))
    console.log(formik.values.discount)

    console.log('portal', formik.values.portal)
  }

  let expirePrice = 2400000

  if (expired && expiredPublicCoursePrice) {
    expirePrice = expiredPublicCoursePrice
  }

  // const replaceRegN = (text) => {
  //   let rexText
  //   if (text.includes('\n')) {
  //     rexText = text.replace(/\n/g, '</br>')
  //   }
  //   return rexText
  // }

  return (
    <Grid item xs={12} sm={12}>
      <Box
        style={{
          height: expired ? 'auto' : '100vh',
        }}
        className={styles.main_register_bank}
      >
        {pathname === '/register' && (
        <Box
          className="register-bank-warp"
          style={{ height: '100%' }}
        >
          <img
            style={{ height: '100%' }}
            src="images/register.png"
            className={styles.register_bank_image}
            alt="Login"
          />

        </Box>
        )}
        <div className={styles.registerFormSectionWrapper}>
          <Grid className={styles.form_section1_bank}>
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              className={styles.new_register_form_section_bank}
            >
              {pathname === '/register'
              && (
              <img
                src="images/logo.svg"
                className={styles.register_bank_logo}
                alt="logo"
              />
              )}

              {!expired && (
              <div className={styles.payDesc}>
                <h3 style={{ marginBottom: '12px' }}>{t('pay_for_the_test')}</h3>
                <p>
                  {`${t('selected_test_for_you')} (${pkg?.name ?? ' '})`}
                </p>

                <span onClick={handleOpen} className={styles.testDescription}>{t('description_exam')}</span>
                <div>
                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    style={{ outline: 'none' }}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                      timeout: 500,
                    }}
                  >
                    <Fade in={open} style={{ outline: 'none' }}>
                      <div className={classes.paper}>
                        <div className={classes.modalContent}>
                          <h2 className={classes.modalTitle} id="transition-modal-title">{t('description_exam')}</h2>

                          {pkg?.description?.includes('\n') ? (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: replaceRegN(pkg?.description)
                            || replaceRegN(pkg?.category?.description),
                              }}
                              className={classes.modalDesc}
                              id="transition-modal-description"
                            />
                          )
                            : (
                              <p>
                                {pkg?.description || pkg?.category?.description}
                              </p>
                            )}

                          {/* {pkg?.description || pkg?.category?.description} */}

                        </div>

                      </div>
                    </Fade>
                  </Modal>
                </div>
              </div>
              )}

              <h4
                style={{ margin: '5px auto 0 auto', borderBottom: discountPrice && '1px solid #c6c6c6', paddingBottom: '10px' }}
              >
                {`${t('fee_payable')}: ${thousandSeperator(expired ? expirePrice : pkg?.price ?? 0)} ${t('rials')}`}

              </h4>
              {discountPrice || discountPrice === 0 ? (
                <>
                  <p style={{ margin: '7px auto' }}>
                    کد تخفیف شما:
                    {' '}
                    {formik.values.discount}
                  </p>

                </>
              ) : null}
              {discountPrice || discountPrice === 0 ? (
                <h4
                  style={{ margin: '5px auto 0 auto', color: 'green' }}
                >
                  {discountPrice !== 0 ? `${t('fee_payable')}: ${discountPrice ? thousandSeperator(discountPrice ?? 0) : thousandSeperator(pkg?.price ?? 0)} ${t('rials')}` : 'رایگان'}
                </h4>
              ) : null}
              <form onSubmit={formik.handleSubmit}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  classes={{ root: classes.root }}
                  style={{ margin: '0 auto' }}
                >
                  <Grid
                    item
                    xs={12}
                    classes={{ root: classes.description }}
                  >

                    <TextField
                      error={Boolean(formik.touched.discount && formik.errors.discount)}
                      helperText={formik.touched.discount && formik.errors.discount}
                      placeholder={`${t('code')} ${t('discount')}`}
                      margin="normal"
                      name="discount"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      type="text"
                      value={formik.values.discount}
                      variant="outlined"
                      fullWidth
                      className={classes.customInput}
                      InputProps={{
                        maxLength: 10,
                        pattern: '[0-9]*',
                        endAdornment: (
                          <Button
                            onClick={addDiscount}
                            position="end"
                            style={{
                              backgroundColor: '#cdcdcd',
                              width: '100px',
                              height: '64px',
                              fontSize: '18px',
                              fontWeight: '550',
                              paddingLeft: '0',
                            }}
                          >
                            {t('save')}
                          </Button>
                        ),
                      }}
                    />

                  </Grid>
                  <Grid
                    xs={12}
                  >
                    <FormGroup classes={{ root: classes.bankGroup }}>
                      {
bankPortals?.map((portal, i) => (
  <FormControlLabel
    // error={Boolean(formik.touched.portal && formik.errors.portal)}
    // helperText={formik.touched.portal && formik.errors.portal}
    classes={{ root: classes.portal, label: classes.portalLabel }}
    key={i}
    control={(
      <GreenCheckbox
        // error={Boolean(formik.touched.portal && formik.errors.portal)}
        // helperText={formik.touched.portal && formik.errors.portal}
        checked={formik.values.portal === portal.name}
        onChange={() => formik.setFieldValue('portal', portal.name)}
        name={portal.name}
      />
)}
    label={(
      <>
        {t(portal.desc)}
        <img src={portal.url} alt={portal.name} className={classes.bankImage} />
      </>
)}
  />
))
}

                      {/* {!!formik.values.portal && (
                      <span className={classes.checkboxError}>
                        Hi
                        {formik.values.portal}
                      </span>
                      )} */}

                    </FormGroup>
                  </Grid>
                  <Grid xs={12} sm={12} md={12} classes={{ root: classes.buttonContainer }}>
                    {expired ? (
                      <Button
                        fullWidth
                        classes={{ root: classes.buttonPayment }}
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        disabled={Boolean(!formik.values.portal)}
                      >
                        {t('payment')}
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        classes={{ root: classes.buttonPayment }}
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        disabled={Boolean(!formik.values.portal)}
                      >
                        {t('payment')}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>

        </div>
      </Box>
    </Grid>
  )
}

BankPortal.propTypes = {
  pkg: PropTypes.object,
}

export default withWidth()(BankPortal)
